// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sm-card {
  border-radius: 10px;
  background: #ececec;
  width: 75vw;
  text-align: center;
  margin-left: 10vw;
  padding: 10px;
  font-family: "RedHatDisplay-Bold", sans-serif;
  transition: all 1s ease-in-out;
}

.sm-titulos {
  font-family: "RedHatDisplay-Bold", sans-serif;
}
.sm-color-black-blue {
  color: #2b363b;
  font-weight: 900;
}

.sm-mt-2 {
  margin-top: 2vh;
}

.sm-paso img {
  margin-top: -22vw;
}

.sm-paso p {
  margin-top: 30px;
}

.sm-paso-dos img {
  margin-top: -38vw;
}

.sm-paso-dos p {
  margin-top: 25px;
}

.sm-img-premio {
  max-width: 70vw;
  max-height: 22vh;
  border-radius: 2vh;
  margin-bottom: 1vh;
}

.sm-card h2,
.sm-sorteoHistoryItem h2 {
  margin-bottom: 1vh;
}

.sm-card-header img {
  margin-left: -25px;
}

.sm-card-header,
.sm-card-header-ultimo-sorteo {
  display: flex;
  background: #2b363b;
  margin: -10px -10px;
  border-radius: 11px;
  border: solid 1px #2b363b;
  margin-bottom: 20px;
  height: 7vh;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
}

.sm-card-header h1,
.sm-card-header-ultimo-sorteo h1 {
  color: #fff;
  font-size: 1.8em;
  text-transform: uppercase;
}

.sm-card-header h5,
.sm-card-header-ultimo-sorteo h5 {
  color: #fff;
  font-family: "RedHatDisplay-Regular", sans-serif;
}

.sm-incluye img {
  width: 18px;
  height: 18px;
  margin-top: 14px;
  margin-left: 10px;
}

.sm-sorteo {
  margin-top: 30px;
}

.sm-sorteo span {
  display: block;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #2b363b;
}

.sm-desplegable {
  display: flex;
  justify-content: center;
  margin-top: 2vh;
}

.sm-desplegable img {
  width: 18px;
  height: 18px;
  margin-top: 14px;
  margin-left: 10px;
}

.sm-mymodal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 83vw;
  height: auto;
  max-height: 60%;
  border: 1px solid #ccc;
  background: #fff;
  overflow: auto;
  border-radius: 8px;
  outline: none;
  padding: 5vh 2vh 2vh 2vh;
  justify-content: space-around;
  overflow-x: hidden;
}

.sm-mymodal h2 {
  text-align: center;
  font-size: 8vw;
  font-family: "RedHatDisplay-Black";
}

.sm-boton {
  background-color: #db0b27 !important; /* Green */
  border: none !important;
  color: white !important;
  font-size: 5vw !important;
  width: 100%;
  height: 7vh !important;
  border-radius: 4px !important;
  margin-top: 5vw !important;
}

.sm-sorteoHistoryItem {
  height: 75vh;
  width: 100vw;
  padding-bottom: 8vh;
  overflow: scroll;
}
.sm-titulo-alert-parent {
  text-align: center;
}
.sm-titulo-alert {
  font-size: 3.5vh;
  text-align: center;
}

.sm-text-center {
  text-align: center;
}

.sm-center {
  padding-top: 12vh;
  text-align: center;
  background-color: #f3f3f3;
  min-height: 88vh;
}

.sm-num-premiado {
  font-size: 1.3em;
}

.sm-center-year {
  margin-left: 2vw;
  margin-right: 2vw;
  color: #2b363b;
}

.sm-buttoms-year {
  width: 30vw;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.sm-buttons-year-parent {
  width: 90vw;
  text-align: center;
  justify-content: center;
  display: inline-flex;
}
.sm-center-vertical {
  vertical-align: middle;
}
.sm-buttoms-year button {
  background-color: #f3f3f3;
  color: #2b363b;
  font-size: 2.2vh;
  border: none;
}

.sm-buttoms-year .sm-center-year {
  font-size: 3.5vh;
}

.sm-item-history {
  margin-top: 2vh;
  margin-bottom: 2vh;
  margin-left: 8vw;
  margin-right: 8vw;
  background-color: #ececec;
  border-radius: 10px;
}

.sm-title-container-item-history {
  background-color: #2b363b;
  padding-top: 2vh;
  color: white;
  text-align: center;
  padding-bottom: 2vh;
  border-radius: 5px;
  font-size: 1.8em;
}
.sm-date-container-history-item {
  width: 80vw;
  text-align: center;
  margin-left: 4vw;
  margin-right: 4vw;
}

.sm-myoverlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
}

.sm-red-appbar,
.sm-black-appbar,
.sm-new-appbar {
  background-color: #db0b27;
  height: 10vh;
  border-radius: 100%;
  width: 130%;
  margin-left: -15%;
  position: fixed;
}

.sm-new-appbar {
  background-color: #f3f3f3;
  border-radius: 0;
}

.sm-img-container {
  text-align: center;
  background-color: #db0b27;
  width: 10vw;
  height: 10vw;
}

.sm-imagen-svg {
  padding: 3vw;
  margin: 5vw;
  border-radius: 16px;
}

.sm-contenido-cesta button {
  margin-top: 10px;
  margin-left: 20px;
}

.sm-buttons-history {
  display: flex;
  border-radius: 20;
}

.sm-button-history {
  padding: 0px;
  background-color: #f3f3f3;
  border: none;
  border-radius: 5vw;
  display: flex;
  flex-direction: column;
}

.sm-contenedor-botones {
  width: 100%;
  display: flex;
  justify-content: center;
}

.sm-number-list-item {
  color: #db0b27;
  display: inline-block;
  padding: 0.25em 0.5em;
  min-width: 4em;
  letter-spacing: 0.1em;
  font-feature-settings: "tnum";
  font-variant-numeric: tabular-nums;
  font-family: "OpenSans-Variable", sans-serif !important;
  font-size: 1.1em;
  font-weight: 600;
}

.sm-number-list {
  font-family: "OpenSans-Variable", sans-serif !important;
  width: 75vw;
  font-weight: 700;
  margin: 1vh auto;
}

.sm-boton-como-funciona-alert-parent {
  width: 100%;
}
.sm-texto-contenido-alert-participar-parent {
  font-size: 2.2vh;
  line-height: 3vh !important;
  text-align: center;
}

.sm-margin-1 {
  margin-top: 3vh;
}

.sm-sorteo-verificacion {
  grid-column: 1 / 3;
  margin-top: 4vh;
}

.sm-sorteo-verificacion {
  margin-bottom: 2vh;
  font-family: "RedHatDisplay-Regular", sans-serif;
  text-align: center;
}

.sm-sorteo-verificacion span,
.sm-sorteo-verificacion-item span {
  color: #db0b27;
  font-size: 1.1em;
  font-weight: 700;
}

.sm-sorteo-info-premiado {
  display: flex;
  align-items: center;
}

.sm-sorteo-info-icon {
  margin-left: 0.5vw;
  margin-right: 2vw;
}

.sm-sorteo-info-text {
  font-family: "RedHatDisplay-Regular", sans-serif;
  font-weight: 400;
  text-align: left;
  font-size: 0.8em;
}

.sm-sorteo-info-text-bold {
  font-weight: 700;
}

.sm-loading-text {
  font-family: "RedHatDisplay-Regular", sans-serif;
}

.sm-mt-4 {
  margin-top: 4vh;
}

.sm-mt-2 {
  margin-top: 2vh;
}

.sm-mt-1-block {
  display: inline-block;
  margin-top: 1vh;
}

.sm-pb-5 {
  padding-bottom: 5vh;
}

.sm-texto-contenido-legal-apple {
  font-style: italic;
  margin-top: 1.5vh;
  text-align: center;
}

.sm-noinfo {
  font-family: "RedHatDisplay-Regular", sans-serif;
  width: 80vw;
  margin: 4em auto;
  color: #db0b27;
  font-weight: 600;
  font-size: 1.3em;
}
`, "",{"version":3,"sources":["webpack://./src/sorteo-mensual/sorteo-mensual.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,6CAA6C;EAC7C,8BAA8B;AAChC;;AAEA;EACE,6CAA6C;AAC/C;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oCAAoC,EAAE,UAAU;EAChD,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,qCAAqC;AACvC;;AAEA;;;EAGE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,6BAAkC;EAAlC,kCAAkC;EAClC,uDAAuD;EACvD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uDAAuD;EACvD,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB","sourcesContent":[".sm-card {\n  border-radius: 10px;\n  background: #ececec;\n  width: 75vw;\n  text-align: center;\n  margin-left: 10vw;\n  padding: 10px;\n  font-family: \"RedHatDisplay-Bold\", sans-serif;\n  transition: all 1s ease-in-out;\n}\n\n.sm-titulos {\n  font-family: \"RedHatDisplay-Bold\", sans-serif;\n}\n.sm-color-black-blue {\n  color: #2b363b;\n  font-weight: 900;\n}\n\n.sm-mt-2 {\n  margin-top: 2vh;\n}\n\n.sm-paso img {\n  margin-top: -22vw;\n}\n\n.sm-paso p {\n  margin-top: 30px;\n}\n\n.sm-paso-dos img {\n  margin-top: -38vw;\n}\n\n.sm-paso-dos p {\n  margin-top: 25px;\n}\n\n.sm-img-premio {\n  max-width: 70vw;\n  max-height: 22vh;\n  border-radius: 2vh;\n  margin-bottom: 1vh;\n}\n\n.sm-card h2,\n.sm-sorteoHistoryItem h2 {\n  margin-bottom: 1vh;\n}\n\n.sm-card-header img {\n  margin-left: -25px;\n}\n\n.sm-card-header,\n.sm-card-header-ultimo-sorteo {\n  display: flex;\n  background: #2b363b;\n  margin: -10px -10px;\n  border-radius: 11px;\n  border: solid 1px #2b363b;\n  margin-bottom: 20px;\n  height: 7vh;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-evenly;\n}\n\n.sm-card-header h1,\n.sm-card-header-ultimo-sorteo h1 {\n  color: #fff;\n  font-size: 1.8em;\n  text-transform: uppercase;\n}\n\n.sm-card-header h5,\n.sm-card-header-ultimo-sorteo h5 {\n  color: #fff;\n  font-family: \"RedHatDisplay-Regular\", sans-serif;\n}\n\n.sm-incluye img {\n  width: 18px;\n  height: 18px;\n  margin-top: 14px;\n  margin-left: 10px;\n}\n\n.sm-sorteo {\n  margin-top: 30px;\n}\n\n.sm-sorteo span {\n  display: block;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.25;\n  letter-spacing: normal;\n  color: #2b363b;\n}\n\n.sm-desplegable {\n  display: flex;\n  justify-content: center;\n  margin-top: 2vh;\n}\n\n.sm-desplegable img {\n  width: 18px;\n  height: 18px;\n  margin-top: 14px;\n  margin-left: 10px;\n}\n\n.sm-mymodal {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 83vw;\n  height: auto;\n  max-height: 60%;\n  border: 1px solid #ccc;\n  background: #fff;\n  overflow: auto;\n  border-radius: 8px;\n  outline: none;\n  padding: 5vh 2vh 2vh 2vh;\n  justify-content: space-around;\n  overflow-x: hidden;\n}\n\n.sm-mymodal h2 {\n  text-align: center;\n  font-size: 8vw;\n  font-family: \"RedHatDisplay-Black\";\n}\n\n.sm-boton {\n  background-color: #db0b27 !important; /* Green */\n  border: none !important;\n  color: white !important;\n  font-size: 5vw !important;\n  width: 100%;\n  height: 7vh !important;\n  border-radius: 4px !important;\n  margin-top: 5vw !important;\n}\n\n.sm-sorteoHistoryItem {\n  height: 75vh;\n  width: 100vw;\n  padding-bottom: 8vh;\n  overflow: scroll;\n}\n.sm-titulo-alert-parent {\n  text-align: center;\n}\n.sm-titulo-alert {\n  font-size: 3.5vh;\n  text-align: center;\n}\n\n.sm-text-center {\n  text-align: center;\n}\n\n.sm-center {\n  padding-top: 12vh;\n  text-align: center;\n  background-color: #f3f3f3;\n  min-height: 88vh;\n}\n\n.sm-num-premiado {\n  font-size: 1.3em;\n}\n\n.sm-center-year {\n  margin-left: 2vw;\n  margin-right: 2vw;\n  color: #2b363b;\n}\n\n.sm-buttoms-year {\n  width: 30vw;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n}\n.sm-buttons-year-parent {\n  width: 90vw;\n  text-align: center;\n  justify-content: center;\n  display: inline-flex;\n}\n.sm-center-vertical {\n  vertical-align: middle;\n}\n.sm-buttoms-year button {\n  background-color: #f3f3f3;\n  color: #2b363b;\n  font-size: 2.2vh;\n  border: none;\n}\n\n.sm-buttoms-year .sm-center-year {\n  font-size: 3.5vh;\n}\n\n.sm-item-history {\n  margin-top: 2vh;\n  margin-bottom: 2vh;\n  margin-left: 8vw;\n  margin-right: 8vw;\n  background-color: #ececec;\n  border-radius: 10px;\n}\n\n.sm-title-container-item-history {\n  background-color: #2b363b;\n  padding-top: 2vh;\n  color: white;\n  text-align: center;\n  padding-bottom: 2vh;\n  border-radius: 5px;\n  font-size: 1.8em;\n}\n.sm-date-container-history-item {\n  width: 80vw;\n  text-align: center;\n  margin-left: 4vw;\n  margin-right: 4vw;\n}\n\n.sm-myoverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.sm-red-appbar,\n.sm-black-appbar,\n.sm-new-appbar {\n  background-color: #db0b27;\n  height: 10vh;\n  border-radius: 100%;\n  width: 130%;\n  margin-left: -15%;\n  position: fixed;\n}\n\n.sm-new-appbar {\n  background-color: #f3f3f3;\n  border-radius: 0;\n}\n\n.sm-img-container {\n  text-align: center;\n  background-color: #db0b27;\n  width: 10vw;\n  height: 10vw;\n}\n\n.sm-imagen-svg {\n  padding: 3vw;\n  margin: 5vw;\n  border-radius: 16px;\n}\n\n.sm-contenido-cesta button {\n  margin-top: 10px;\n  margin-left: 20px;\n}\n\n.sm-buttons-history {\n  display: flex;\n  border-radius: 20;\n}\n\n.sm-button-history {\n  padding: 0px;\n  background-color: #f3f3f3;\n  border: none;\n  border-radius: 5vw;\n  display: flex;\n  flex-direction: column;\n}\n\n.sm-contenedor-botones {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n\n.sm-number-list-item {\n  color: #db0b27;\n  display: inline-block;\n  padding: 0.25em 0.5em;\n  min-width: 4em;\n  letter-spacing: 0.1em;\n  font-variant-numeric: tabular-nums;\n  font-family: \"OpenSans-Variable\", sans-serif !important;\n  font-size: 1.1em;\n  font-weight: 600;\n}\n\n.sm-number-list {\n  font-family: \"OpenSans-Variable\", sans-serif !important;\n  width: 75vw;\n  font-weight: 700;\n  margin: 1vh auto;\n}\n\n.sm-boton-como-funciona-alert-parent {\n  width: 100%;\n}\n.sm-texto-contenido-alert-participar-parent {\n  font-size: 2.2vh;\n  line-height: 3vh !important;\n  text-align: center;\n}\n\n.sm-margin-1 {\n  margin-top: 3vh;\n}\n\n.sm-sorteo-verificacion {\n  grid-column: 1 / 3;\n  margin-top: 4vh;\n}\n\n.sm-sorteo-verificacion {\n  margin-bottom: 2vh;\n  font-family: \"RedHatDisplay-Regular\", sans-serif;\n  text-align: center;\n}\n\n.sm-sorteo-verificacion span,\n.sm-sorteo-verificacion-item span {\n  color: #db0b27;\n  font-size: 1.1em;\n  font-weight: 700;\n}\n\n.sm-sorteo-info-premiado {\n  display: flex;\n  align-items: center;\n}\n\n.sm-sorteo-info-icon {\n  margin-left: 0.5vw;\n  margin-right: 2vw;\n}\n\n.sm-sorteo-info-text {\n  font-family: \"RedHatDisplay-Regular\", sans-serif;\n  font-weight: 400;\n  text-align: left;\n  font-size: 0.8em;\n}\n\n.sm-sorteo-info-text-bold {\n  font-weight: 700;\n}\n\n.sm-loading-text {\n  font-family: \"RedHatDisplay-Regular\", sans-serif;\n}\n\n.sm-mt-4 {\n  margin-top: 4vh;\n}\n\n.sm-mt-2 {\n  margin-top: 2vh;\n}\n\n.sm-mt-1-block {\n  display: inline-block;\n  margin-top: 1vh;\n}\n\n.sm-pb-5 {\n  padding-bottom: 5vh;\n}\n\n.sm-texto-contenido-legal-apple {\n  font-style: italic;\n  margin-top: 1.5vh;\n  text-align: center;\n}\n\n.sm-noinfo {\n  font-family: \"RedHatDisplay-Regular\", sans-serif;\n  width: 80vw;\n  margin: 4em auto;\n  color: #db0b27;\n  font-weight: 600;\n  font-size: 1.3em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
